import React from 'react';
import { Link } from 'react-router-dom';
import { Button, colors } from '@mui/material';
import { PVBlack, PVGray } from '@pv/common/colors';
import { Bell } from '../../../components/icons/CategoryIcons';

export const FindAVenueButton = () => {
  return (
    <Button
      variant="contained"
      color="primary"
      component={Link}
      to="https://www.perfectvenue.com/concierge"
      target="_blank"
      startIcon={<Bell />}
      sx={{
        borderRadius: '500px',
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: '14px',
        backgroundColor: PVBlack,
        '&:hover': {
          backgroundColor: PVGray,
        },
        svg: { stroke: 'white' },
      }}
    >
      Find a venue
    </Button>
  );
};
